import {
  Bestellung,
  IdRequest,
  RemoteResult,
  AbholungStatus,
  AbholzeitType,
  DateTimeCapsule,
  LoadState,
} from "mangdto"
import store from "@/store"
import RestPaths from "@/util/rest_paths"
import Poster from "@/util/poster"
import { EnumFormatter, SocketMessageType } from "mangutil"
import Formatter from "../formatter"
import axios from "axios"
import { saveAs } from "file-saver"
import BaseLogic from "../base_logic"

export default class DetailsAbholungLogic extends BaseLogic {
  bestellung: Bestellung = null
  navigator = null
  stornierenLoadState: LoadState = LoadState.Idle
  abholbereitListener: () => void

  rechnungErstellen() {
    var request = new IdRequest()
    request.id = this.bestellung.id

    Poster.postUser<any>(RestPaths.bestellungKundeRechnungSenden, request).then(
      (response) => {},
    )
  }

  berechneGesamtpreis(): number {
    var artikellistepreis = Formatter.berechnePreisListe(
      this.bestellung.artikelliste,
    )
    return artikellistepreis
  }

  berechneGesamtpreisTrinkgeld(): number {
    var gesamtpreis = this.berechneGesamtpreis()

    var trinkgeld = this.bestellung.trinkgeld
    if (trinkgeld != null) {
      gesamtpreis = gesamtpreis + trinkgeld
    }
    return gesamtpreis
  }

  init(navigator: Navigator) {
    this.bestellung = this.mainLogic.bestellung
    this.navigator = navigator

    store.watch(
      (state) => state.incomingMessage,
      (newValue) => {
        if (newValue) {
          if (newValue.type == SocketMessageType.ABHOLUNG_STATUS_UPDATE) {
            var payload = JSON.parse(newValue.payload)
            if (payload.id == this.bestellung.id) {
              var status = payload.status
              this.bestellung.abholung.status = status

              if (status == AbholungStatus.Abholbereit) {
                if (this.abholbereitListener) {
                  this.abholbereitListener()
                }
              }

              this.reloadBestellung()
            }
          }
        }
      },
    )
  }

  createPdf() {
    var request = new IdRequest()
    request.id = this.bestellung.id

    axios
      .post(
        RestPaths.urlBase + RestPaths.bestellungKundeBestellungRechnung,
        request,
        {
          responseType: "blob",
        },
      )
      .then((response) => {
        saveAs(response.data, "PDF.pdf")
      })
  }

  reloadBestellung() {
    var request = new IdRequest()
    request.id = this.bestellung.id

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungKundeDetails,
      request,
    ).then((response) => {
      if (response.data.success) {
      }
    })
  }

  computeAbholzeit() {
    if (this.bestellung.abholung.type == AbholzeitType.Baldest) {
      return "schnellst möglich"
    } else if (this.bestellung.abholung.type == AbholzeitType.Uhrzeit) {
      return Formatter.formatiereDatumUhrzeit(
        this.bestellung.abholung.gewaehlterAbholZp,
      )
    }
  }

  bestellungAbholbereit() {
    if (this.bestellung.abholung.status == AbholungStatus.Abholbereit)
      return true
    return false
  }

  bestimmeBild(bestellung: Bestellung) {
    if (bestellung == null) return null
    var bildId = this.filiale.bildId
    if (bildId == null) return null
    return RestPaths.urlBase + "images/image2/" + bildId
  }

  formatiereStatus() {
    if (this.bestellung == null) return null
    return EnumFormatter.formatAbholungStatus(this.bestellung.abholung.status)
  }

  formatiereTisch() {
    if (this.bestellung == null) return null
    if (this.bestellung.abholung == null) return null
    if (this.bestellung.abholung.tischId == null) return "---"
    return "Tisch " + this.bestellung.abholung.tischBezeichnung
  }

  stornieren(finishedHandler: () => void) {
    this.stornierenLoadState = LoadState.Loading

    var request = new IdRequest()
    request.id = this.bestellung.id

    Poster.postUser<RemoteResult<DateTimeCapsule>>(
      RestPaths.bestellungKundeStornieren,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.stornierenLoadState = LoadState.Completed

          this.bestellung.storniert = true
          this.bestellung.abgeschlossen = true
          if (finishedHandler) {
            finishedHandler()
          }
        } else {
          this.stornierenLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.stornierenLoadState = LoadState.Error
      })
  }
}
